export const GET_AGENCIES = "GET_AGENCIES";
export const GET_AGENCIES_SUCCESS = "GET_AGENCIES_SUCCESS";
export const GET_AGENCIES_FAIL = "GET_AGENCIES_FAIL";
export const UPDATE_AGENCIES_DATA = "UPDATE_AGENCIES_DATA";

export const GET_AGENCY_VIEW = "GET_AGENCY_VIEW";
export const GET_AGENCY_VIEW_SUCCESS = "GET_AGENCY_VIEW_SUCCESS";
export const GET_AGENCY_VIEW_FAIL = "GET_AGENCY_VIEW_FAIL";
